import { NodeId, useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "@/components/shared/tooltip";
import { formatTestId } from "@/utils/format-test-id";

import { ListWrapper, StyledButton } from "./image-positioner-component-styles";

const positions = [
  "top left",
  "top center",
  "top right",
  "left center",
  "center center",
  "right center",
  "left bottom",
  "center bottom",
  "right bottom",
] as const;

export type ImagePosition = typeof positions[number];

type ImagePositionerProps = {
  nodeId?: NodeId;
  imagePropName?: string;
};

export default function ImagePositioner(ownProps: ImagePositionerProps) {
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props,
  }));

  const { t } = useTranslation();

  const createClickHandler = (position: string) => () => {
    setProp((props) => {
      return (props[ownProps.imagePropName] = position);
    });
  };

  return (
    <ListWrapper>
      {positions.map((position) => {
        const label = t(
          `preference-panel.position.${position.replace(" ", "-")}`
        );
        return (
          <li key={position} data-testid="image-position-item">
            <Tooltip
              placement="top-center"
              tooltip={label}
              childClassName="capitalize"
            >
              <StyledButton
                data-testid={formatTestId(position, "image-position-button")}
                onClick={createClickHandler(position)}
                $active={props[ownProps.imagePropName] === position}
              >
                <span className="sr-only">{label}</span>
              </StyledButton>
            </Tooltip>
          </li>
        );
      })}
    </ListWrapper>
  );
}
